import {
  Step,
  StepConnector,
  stepConnectorClasses,
  StepLabel,
  Stepper,
  styled,
  Typography,
} from '@mui/material';
import { Statuses } from 'API';
import { CustomStepperIcon } from 'Components';
import { shorterDateFormat } from 'Config';
import { useIsDesktop } from 'Hooks';
import { Status } from 'Modules/MedicineOrderInfo/Status';
import { format } from 'date-fns';

interface MedicineStepperProps {
  steps: Statuses[];
  currentStep: number;
}

const CustomStepMobile = styled(StepConnector)(() => ({
  marginLeft: '11.5px',
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#1752AF',
      minHeight: '40px',
    },
  },
  [`&.${stepConnectorClasses.disabled}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      minHeight: '40px',
    },
  },
}));

const CustomStepDesktop = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.disabled}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#E4C1FF',
      height: '48px',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#1752AF',
    },
  },
}));

const CustomConnector = () => {
  const isDesktop = useIsDesktop();
  return isDesktop ? <CustomStepDesktop /> : <CustomStepMobile />;
};

export const MedicineOrderStepper = ({
  steps,
  currentStep,
}: MedicineStepperProps) => {
  const isDesktop = useIsDesktop();

  return isDesktop ? (
    <Stepper
      alternativeLabel
      connector={<CustomConnector />}
      aria-hidden={'true'}
      orientation='vertical'
      sx={{ p: '24px', height: 'fit-content', width: '41%' }}
    >
      {steps.map((step) => (
        <Step
          key={step.calcStatus}
          completed={currentStep > step.calcStatus}
          sx={{
            width: '100%',
            '& .MuiStepConnector-root': { position: 'initial' },
          }}
          active={step.calcStatus === currentStep}
        >
          <StepLabel
            StepIconComponent={CustomStepperIcon}
            sx={{
              display: 'flex',
              '&.MuiStepLabel-alternativeLabel': {
                flexDirection: 'row',
                alignItems: 'start',
              },
              '& .MuiStepLabel-label': {
                mt: 0,
                textAlign: 'left',
                ml: '12px',
                height: step.statusDate ? '60px' : '22px',
              },
            }}
          >
            {step.calcStatus === currentStep ? (
              <Status status={step.calcStatus} statusLabel={step.label || ''} />
            ) : (
              <>
                <Typography variant='body5'>{step.label}</Typography>
              </>
            )}
            {!!step.statusDate && (
              <Typography
                variant='body5'
                component={'p'}
                sx={{ position: 'absolute', pt: '10px' }}
              >
                {format(new Date(step.statusDate), shorterDateFormat)}
              </Typography>
            )}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  ) : (
    <Stepper
      orientation='vertical'
      connector={<CustomConnector />}
      sx={{ marginTop: '16px', marginBottom: '48px' }}
    >
      {/* {steps.map((step) => (
        <Step
          key={step.calcStatus}
          completed={currentStep > step.calcStatus}
          active={step.calcStatus === currentStep}
          sx={{ width: '100%' }}
        >
          <StepLabel
            StepIconComponent={CustomStepperIcon}
            sx={{
              position: 'relative',
              p: 0,
              top: step.calcStatus === currentStep ? '3px' : '',
              marginTop: step.calcStatus === currentStep ? '-7px' : '',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: '-1.5px',
              }}
            >
              <Typography
                color={step.calcStatus === currentStep ? '#1752AF' : ''}
                fontWeight={step.calcStatus === currentStep ? 700 : ''}
              >
                {step.label}
              </Typography>
            </Box>
          </StepLabel>
        </Step>
      ))} */}
    </Stepper>
  );
};
